import React, { useState, useEffect,useRef } from 'react';
import PropTypes from 'prop-types';
import './canvasComponent.scss';
import {IconType} from '../../atoms/icon/icon';
import { IconSize } from '../../atoms/icon/icon';
import MoveIcon from '../../atoms/customIcons/moveIcon.svg';
import Button, { ButtonSize, ButtonTheme, ButtonType } from '../../atoms/button/button';
import CanvasBlocksComponent from './canvasBlocksComponent';
import { getContainerIndex } from '../../../utils/canvasUtils';
/**
 * Canvas Container component 
 */
const CanvasContainerComponent = (props) => {
  const {
    mode,
    canvasMode,
    maxItems,
    index,
    container,
    infoContent,
    blockSelected,
    dragParams,
    onNewContainer,
    onDeleteContainer,
    onUpdateContainer,
    onInfoClicked,
    onBlockSelected,
    dateSelected,
    onUpdateInfoContent,
  } = props;
  const childRef = useRef();
  const [newBlockTrigger,setNewBlockTrigger] =useState(false);
  const [canCreateBlocks,setCanCreateBlocks] =useState(true);
  const [displayBlocks,setDisplayBlocks] =useState([]);
  const [allBlocks,setAllBlocks] =useState([]);

  useEffect(() => {
    getBlocksFromDate(container.blocks,dateSelected);
  }, [dateSelected,infoContent]);
  
  const getBlocksFromDate=(blocks,d)=>{
    let found;
    if(blocks){
      found=blocks.filter((block)=>{
        return checkBlockOk(block,d)
      });
      setDisplayBlocks(found);
      setAllBlocks(blocks);
    }
  }
  function checkBlockOk(block,d) {
    if(block.startEpoch==d)
      block.init=true;
    if(block.endEpoch==d)
      block.end=true;
    return (block.startEpoch<=d && (block.endEpoch>d || block.endEpoch===0));
  }
  const handleAddBlock=()=>{
    if (childRef.current){ 
      childRef.current.handleAddBlock(index);
    }
    // setNewBlockTrigger(true);
  }

  const handleOnInfoClicked=(value)=>{
    onInfoClicked(value);
  }
  const onDeleteBlocks=(containerIndex,blockToDelete)=>{
    let blocksFiltered = allBlocks.filter((element)=>{
      if(element.UID!=blockToDelete.UID)
        return element;
    });
    setAllBlocks(blocksFiltered);
    container.blocks=blocksFiltered;
    setNewBlockTrigger(false);
    setCanCreateBlocks(true);
    onUpdateContainer(containerIndex,container);

  }
  const onUpdateBlocks=(containerIndex,newBlocks,canCreate)=>{
    let merge=allBlocks;
  
    for(let newP in newBlocks){
      let found=allBlocks.findIndex((item)=>item.UID===newBlocks[newP].UID);
      if (found==-1){
        merge=[...merge,newBlocks[newP]];
      }else{
        merge[found]=newBlocks[newP];
      }
    }
    setAllBlocks(merge);
    container.blocks=merge;
    setNewBlockTrigger(false);
    setCanCreateBlocks(canCreate);
    onUpdateContainer(containerIndex,container,canvasMode);
  }

  const handleCopyBlock=()=>{
    alert("copy block TBD");
  }

  const handleDeleteContainer=(index)=>{
    onDeleteContainer(index,canvasMode);
  }

  const handleAddNewContainer=(index,maxItems)=>{
    let i= getContainerIndex(index,maxItems);
    onNewContainer(index,canvasMode);
  }
  const handleOnBlockSelected=(uid)=>{
    onBlockSelected(uid);
  }
  const handleOnInfoContent=(newElem)=>{
    onUpdateInfoContent(newElem);
  }
  return (
    <>
        {(container && !container.created || container.created==false) && 
          <div className={'container--content '+' container--content-'+(mode==1?"back":"front")+ " container--content--"+canvasMode}>
            <div className={"container--content-child"}  {...dragParams} >
              <div className="empty-title">{canvasMode} {getContainerIndex(index,maxItems)}</div>
              <Button
                  key={canvasMode+`button-add-container-`+index}
                  className={"button"}
                  id={canvasMode+`-button-add-container-`+index}

                  type={ButtonType.BUTTON}
                  icon={IconType.NEW}
                  theme={ButtonTheme.DARK}
                  title={"<br/>Add new container"}
                  onClick={()=>{handleAddNewContainer(index,maxItems)}}
              >
                <span>Add new container</span>
              </Button>
            </div>
          </div>}
        {container && container.created && 
          <div>
            <div className="header-container" {...dragParams} >
              <div className="header-row">
                <img className="icon" src={MoveIcon} />
              </div> 
              <div className="header-row">
                {canvasMode} {getContainerIndex(index,maxItems)}
              </div>
            </div>
            <div className="header-actions-container">
              <Button
                id={canvasMode+'-container-'+index+'-button-add-block'}
                className="button-action button-add-block"
                type={'button'}
                onClick={handleAddBlock}
                icon={IconType.NEW}
                iconSize={IconSize.SMALL}
                disabled={!canCreateBlocks}
                iconColor={"#000000"}
                size={ButtonSize.SMALL}
              >
              </Button>
              {/* <Button
                id={'button-copy-container'}
                className="button-action"
                type={'button'}
                onClick={handleCopyBlock}
                icon={IconType.COPY}
                iconSize={IconSize.SMALL}
                iconColor={"#000000"}
                size={ButtonSize.SMALL}
              >
              </Button> */}
              <Button
                id={canvasMode+'-container-'+index+'-button-delete-container'}
                className="button-action button-delete-container"
                type={'button'}
                onClick={()=>{handleDeleteContainer(index)}}
                icon={IconType.DELETE}
                iconSize={IconSize.SMALL}
                iconColor={"#000000"}
                size={ButtonSize.SMALL}
              >
              </Button>
            </div>
            <div className={'body-container'+ ' body-container--'+canvasMode }>
              <div className={'item-separation'}>
                <div className="content-inline canvas-blocks">
                  {displayBlocks && 
                  <CanvasBlocksComponent
                      ref={childRef}
                      canvasId={container.canvasId?container.canvasId:null}
                      containerId={container.id}
                      mode={mode}
                      canvasMode={canvasMode}
                      newBlockTrigger={newBlockTrigger} 
                      value={displayBlocks} 
                      infoContent={infoContent}
                      allBlocks={allBlocks}
                      dateSelected={dateSelected}
                      blockSelected={blockSelected}
                      name={container.id} 
                      size={container.size} 
                      type={container.type}
                      onInfoClicked={handleOnInfoClicked}
                      onUpdateBlocks={(blocks,canCreate)=>{
                        onUpdateBlocks(index,blocks,canCreate);}} 
                      onDeleteBlocks={(blocks)=>{
                        onDeleteBlocks(index,blocks);}} 
                      onBlockSelected={handleOnBlockSelected}
                      onUpdateInfoContent={handleOnInfoContent}
                  />}
                </div>
              </div>
            </div>
          </div>}
    </>
  );
};

CanvasContainerComponent.propTypes = {
    /**
     * Container
     */
    container:PropTypes.object,
    /**
     * List of items of the container
     */
    items:PropTypes.array,
    blockSelected:PropTypes.oneOfType([PropTypes.number,PropTypes.string])

};

CanvasContainerComponent.defaultProps = {
    container:{},
    name:'',
    type:'staticImage',
    blockSelected:null
  };
export default CanvasContainerComponent;
